import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AdminUserDto,
  AuthTokenResponse,
  CurrentUserResponse,
  GoogleTokenExchangeRequest,
  RoleCatalogItemDto,
  UpdateUserRolesRequest,
  UserRolesResponse
} from './auth-api.types';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  constructor(private readonly http: HttpClient) {}

  exchangeGoogleToken(request: GoogleTokenExchangeRequest): Observable<AuthTokenResponse> {
    return this.http.post<AuthTokenResponse>('/api/auth/google/exchange', request);
  }

  getCurrentUser(): Observable<CurrentUserResponse> {
    return this.http.get<CurrentUserResponse>('/api/auth/me');
  }

  getAdminUsers(): Observable<AdminUserDto[]> {
    return this.http.get<AdminUserDto[]>('/api/auth/admin/users');
  }

  getAdminRoleCatalog(): Observable<RoleCatalogItemDto[]> {
    return this.http.get<RoleCatalogItemDto[]>('/api/auth/admin/roles');
  }

  updateUserRoles(userId: string, body: UpdateUserRolesRequest): Observable<UserRolesResponse> {
    return this.http.put<UserRolesResponse>(`/api/auth/admin/users/${encodeURIComponent(userId)}/roles`, body);
  }
}
